export function createRecurrenceWorker(): Worker {
  return new Worker(new URL('./groupcalRecurrenceWorker.ts', import.meta.url))
}
